module.exports = __webpack_public_path__ + "491a4be0dbe2faf194b86a176add2cd9.png";